import Style from "./css/style.module.css";

function ListArea(props: any) {
  let myProps = {
    infoArr: [],
    ...props
  };
  let infoArr = myProps.infoArr;
  let key_name_arr: any = [];
  if (infoArr.length > 0) {
    let first_info = infoArr[0];
    for (let key in first_info) {
      key_name_arr.push(key);
    }
  }

  const get_info_rows = () => {
    let row_tags: any = infoArr.map((info: any, index: number) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          {key_name_arr.map((key_name: any) => (
            <td key={key_name}>{info[key_name]}</td>
          ))}
        </tr>
      );
    });

    return row_tags;
  };

  return (
    <div className={Style.table_container}>
      <table className={Style.data_table}>
        <thead>
          <tr>
            <th>No.</th>
            {key_name_arr.map((key_name: any) => (
              <th key={key_name}>{key_name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {get_info_rows()}
        </tbody>
      </table>
    </div>
  );
};
export default ListArea;